import { render } from "./LSection.vue?vue&type=template&id=5a972e2e"
import script from "./LSection.vue?vue&type=script&lang=js"
export * from "./LSection.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__